import script from "./supplierEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./supplierEdit.vue?vue&type=script&setup=true&lang=js"

import "./supplierEdit.vue?vue&type=style&index=0&id=ce9f5a00&lang=scss&scoped=true"
import "./supplierEdit.vue?vue&type=style&index=1&id=ce9f5a00&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce9f5a00"]])

export default __exports__